<template>
  <div id="bd-auth">
    <el-container>
      <el-main>
        <transition mode="out-in" enter-active-class="fadeIn" leave-active-class="fadeOut" appear>
          <router-view class="animated"></router-view>
        </transition>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'bd-auth'
}
</script>

<style scoped>
#bd-auth {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
}
.el-container {
  height: 100%;
}
.el-main {
  height: 100%;
}
.el-footer {
  background-color: #f9f9f9;
  text-align: center;
}
</style>
